import { ERentioFormField } from "../../components/components/Form";
import { CONFIG } from "../../config/app.config";
import { getValue, mapFormFieldBooleanToSummary, } from "../../redux/form/form.utils";
import { EHeatingType, EPropertyAdjoined } from "../../types/property.types";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { formatCurrency } from "../../utils/number.utils";
import { EField } from "./schema.createContract.types";
import { getNavigationTitle } from "./schema.createContract.utils";
var booleanOptions = [
    {
        value: getLocalizedText("system.no"),
        id: "no",
    },
    {
        value: getLocalizedText("system.yes"),
        id: "yes",
    },
];
export var getSchema = function (initialValues, _a) {
    var contract = _a.contract, property = _a.property;
    return function (defaultValues) {
        var _a;
        return {
            required: [],
            properties: (_a = {},
                _a[EField.Header + "13"] = {
                    default: undefined,
                },
                _a[EField.IsSharedLease] = {
                    default: getValue(EField.IsSharedLease, initialValues, defaultValues),
                    // @ts-ignore
                    options: ["yes", "no"].map(function (id) { return ({
                        id: id,
                        value: getLocalizedText("system.".concat(id).toLowerCase()),
                    }); }),
                },
                _a[EField.ReferencePrice] = {
                    default: getValue(EField.ReferencePrice, initialValues, defaultValues),
                    minimum: 1,
                },
                // Brussels Registration - Property Amenity Fields
                _a[EField.ConstructionYear] = {
                    default: getValue(EField.ConstructionYear, initialValues, defaultValues),
                    minimum: 1800,
                    maximum: new Date().getFullYear(),
                },
                _a[EField.BuildingAdjoined] = {
                    default: getValue(EField.BuildingAdjoined, initialValues, defaultValues),
                    // @ts-ignore
                    options: [
                        EPropertyAdjoined.Freestanding,
                        EPropertyAdjoined.OneSide,
                        EPropertyAdjoined.BothSides,
                        EPropertyAdjoined.Unknown,
                    ].map(function (id) { return ({
                        id: id,
                        value: getLocalizedText("property.adjoined.option.".concat(id, ".label").toLowerCase()),
                    }); }),
                },
                _a[EField.BuildingSurfaceArea] = {
                    default: getValue(EField.BuildingSurfaceArea, initialValues, defaultValues),
                    minimum: 1,
                },
                _a[EField.BuildingFloor] = {
                    default: getValue(EField.BuildingFloor, initialValues, defaultValues),
                    minimum: 0,
                },
                _a[EField.BuildingFloorCount] = {
                    default: getValue(EField.BuildingFloorCount, initialValues, defaultValues),
                    minimum: 1,
                },
                _a[EField.RoomCountBedroom] = {
                    default: getValue(EField.RoomCountBedroom, initialValues, defaultValues),
                    minimum: 0,
                },
                _a[EField.RoomCountBathroom] = {
                    default: getValue(EField.RoomCountBathroom, initialValues, defaultValues),
                    minimum: 0,
                },
                _a[EField.RoomCountGarage] = {
                    default: getValue(EField.RoomCountGarage, initialValues, defaultValues),
                    minimum: 0,
                },
                _a[EField.BuildingHasStorage] = {
                    default: getValue(EField.BuildingHasStorage, initialValues, defaultValues),
                    // @ts-ignore
                    options: booleanOptions,
                },
                _a[EField.IsFurnished] = {
                    default: getValue(EField.IsFurnished, initialValues, defaultValues),
                    // @ts-ignore
                    options: booleanOptions,
                },
                _a[EField.HasOven] = {
                    default: getValue(EField.HasOven, initialValues, defaultValues),
                    // @ts-ignore
                    options: booleanOptions,
                },
                _a[EField.HasFridge] = {
                    default: getValue(EField.HasFridge, initialValues, defaultValues),
                    // @ts-ignore
                    options: booleanOptions,
                },
                _a[EField.HasDishWasher] = {
                    default: getValue(EField.HasDishWasher, initialValues, defaultValues),
                    // @ts-ignore
                    options: booleanOptions,
                },
                _a[EField.HasRangeHood] = {
                    default: getValue(EField.HasRangeHood, initialValues, defaultValues),
                    // @ts-ignore
                    options: booleanOptions,
                },
                _a[EField.HasLift] = {
                    default: getValue(EField.HasLift, initialValues, defaultValues),
                    // @ts-ignore
                    options: booleanOptions,
                },
                _a[EField.HasDoubleGlazing] = {
                    default: getValue(EField.HasDoubleGlazing, initialValues, defaultValues),
                    // @ts-ignore
                    options: booleanOptions,
                },
                _a[EField.HasCentralHeating] = {
                    default: getValue(EField.HasCentralHeating, initialValues, defaultValues),
                    // @ts-ignore
                    options: booleanOptions,
                },
                _a[EField.HeatingType] = {
                    default: getValue(EField.HeatingType, initialValues, defaultValues),
                    // @ts-ignore
                    options: [
                        EHeatingType.NaturalGas,
                        EHeatingType.Electricity,
                        EHeatingType.HeatPump,
                        EHeatingType.FuelOil,
                        EHeatingType.Coal,
                        EHeatingType.Other,
                    ].map(function (id) { return ({
                        id: id,
                        value: getLocalizedText("property.extra.option.energy.".concat(id).toLowerCase()),
                    }); }),
                },
                _a),
        };
    };
};
export var uiSchema = function (extraData) {
    var _a;
    return _a = {
            "rentio:title": getLocalizedText("contract_info.create.additional_information.heading.summary"),
            "rentio:navigationTitle": getNavigationTitle(extraData)
        },
        _a[EField.Header + "13"] = {
            "ui:field": ERentioFormField.SectionHeader,
            title: getLocalizedText("contract_info.create.additional_information.heading"),
        },
        _a[EField.IsSharedLease] = {
            "ui:field": ERentioFormField.SegmentedControl,
            title: getLocalizedText("contract.is_shared_lease.title"),
            formatSummary: function (value) { return mapFormFieldBooleanToSummary(value); },
            optional: true,
        },
        _a[EField.ReferencePrice] = {
            "ui:field": ERentioFormField.Number,
            formatSummary: function (formData) {
                return formData && formatCurrency(formData);
            },
            title: getLocalizedText("contract.reference_price.label"),
            placeholder: "0",
            suffixText: "EUR",
            isFloat: true,
            decimals: CONFIG.DECIMALS_FOR_CURRENCY,
            optional: true,
        },
        // Brussels Registration - Property Amenity Fields
        _a[EField.ConstructionYear] = {
            "ui:field": ERentioFormField.Number,
            title: getLocalizedText("property.extra.general.item.construction_year"),
            optional: true,
        },
        _a[EField.BuildingAdjoined] = {
            "ui:field": ERentioFormField.DropdownSelect,
            title: getLocalizedText("property.extra.exterior.field.building_adjoined"),
            formatSummary: function (value) {
                return value &&
                    getLocalizedText("property.adjoined.option.".concat(value.toLowerCase(), ".label"));
            },
            optional: true,
        },
        _a[EField.BuildingSurfaceArea] = {
            "ui:field": ERentioFormField.Number,
            title: getLocalizedText("property.extra.exterior.field.building_surface_area"),
            placeholder: "0",
            suffixText: "m²",
            optional: true,
        },
        _a[EField.BuildingFloor] = {
            "ui:field": ERentioFormField.Number,
            title: getLocalizedText("property.extra.interior.field.building_floor"),
            placeholder: "0",
            optional: true,
        },
        _a[EField.BuildingFloorCount] = {
            "ui:field": ERentioFormField.Number,
            title: getLocalizedText("property.extra.interior.field.building_layers"),
            placeholder: "0",
            optional: true,
        },
        _a[EField.RoomCountBedroom] = {
            "ui:field": ERentioFormField.Number,
            title: getLocalizedText("property.extra.interior.field.room_count_bedroom"),
            placeholder: "0",
            optional: true,
        },
        _a[EField.RoomCountBathroom] = {
            "ui:field": ERentioFormField.Number,
            title: getLocalizedText("property.extra.interior.field.room_count_bathroom"),
            placeholder: "0",
            optional: true,
        },
        _a[EField.RoomCountGarage] = {
            "ui:field": ERentioFormField.Number,
            title: getLocalizedText("property.extra.interior.field.room_count_garage"),
            placeholder: "0",
            optional: true,
        },
        _a[EField.BuildingHasStorage] = {
            "ui:field": ERentioFormField.SegmentedControl,
            title: getLocalizedText("property.extra.interior.field.building_has_storage"),
            formatSummary: function (value) { return mapFormFieldBooleanToSummary(value); },
            optional: true,
        },
        _a[EField.IsFurnished] = {
            "ui:field": ERentioFormField.SegmentedControl,
            title: getLocalizedText("property.extra.interior.field.is_furnished"),
            formatSummary: function (value) { return mapFormFieldBooleanToSummary(value); },
            optional: true,
        },
        _a[EField.HasOven] = {
            "ui:field": ERentioFormField.SegmentedControl,
            title: getLocalizedText("property.extra.amenities.item.has_oven"),
            formatSummary: function (value) { return mapFormFieldBooleanToSummary(value); },
            optional: true,
        },
        _a[EField.HasFridge] = {
            "ui:field": ERentioFormField.SegmentedControl,
            title: getLocalizedText("property.extra.amenities.item.has_fridge"),
            formatSummary: function (value) { return mapFormFieldBooleanToSummary(value); },
            optional: true,
        },
        _a[EField.HasDishWasher] = {
            "ui:field": ERentioFormField.SegmentedControl,
            title: getLocalizedText("property.extra.amenities.item.has_dish_washer"),
            formatSummary: function (value) { return mapFormFieldBooleanToSummary(value); },
            optional: true,
        },
        _a[EField.HasRangeHood] = {
            "ui:field": ERentioFormField.SegmentedControl,
            title: getLocalizedText("property.extra.amenities.item.has_range_hood"),
            formatSummary: function (value) { return mapFormFieldBooleanToSummary(value); },
            optional: true,
        },
        _a[EField.HasLift] = {
            "ui:field": ERentioFormField.SegmentedControl,
            title: getLocalizedText("property.extra.amenities.item.has_lift"),
            formatSummary: function (value) { return mapFormFieldBooleanToSummary(value); },
            optional: true,
        },
        _a[EField.HasDoubleGlazing] = {
            "ui:field": ERentioFormField.SegmentedControl,
            title: getLocalizedText("property.extra.energy.item.has_double_glazing"),
            formatSummary: function (value) { return mapFormFieldBooleanToSummary(value); },
            optional: true,
        },
        _a[EField.HasCentralHeating] = {
            "ui:field": ERentioFormField.SegmentedControl,
            title: getLocalizedText("property.extra.energy.item.has_central_heating"),
            formatSummary: function (value) { return mapFormFieldBooleanToSummary(value); },
            optional: true,
        },
        _a[EField.HeatingType] = {
            "ui:field": ERentioFormField.DropdownSelect,
            title: getLocalizedText("property.extra.energy.item.has_heating_type"),
            formatSummary: function (value) {
                return value &&
                    getLocalizedText("property.extra.option.energy.".concat(value.toLowerCase()));
            },
            optional: true,
        },
        _a;
};
